import { render, staticRenderFns } from "./DeferredStarsIndexStarsComponent.vue?vue&type=template&id=964ddf3a"
import script from "./DeferredStarsIndexStarsComponent.vue?vue&type=script&lang=js"
export * from "./DeferredStarsIndexStarsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports